import dashboard from './crmDashboaed'

export default [...dashboard]
